'use client';
import { useEffect } from 'react';
import { DATA_SCROLL_LOCKED } from './RemoveScrollBarGlobal.contract.js';

const getCurrentUseCounter = ()=>{
    const counter = parseInt(document.body.getAttribute(DATA_SCROLL_LOCKED) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
const useLockAttribute = ()=>{
    useEffect(()=>{
        document.body.setAttribute(DATA_SCROLL_LOCKED, (getCurrentUseCounter() + 1).toString());
        return ()=>{
            const newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(DATA_SCROLL_LOCKED);
            } else {
                document.body.setAttribute(DATA_SCROLL_LOCKED, newCounter.toString());
            }
        };
    }, []);
};

export { useLockAttribute };
//# sourceMappingURL=useLockAttribute.js.map
